module.exports = __webpack_public_path__ + "img/container.d3287294.png";